/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import PropTypes from "prop-types";
import { useEffect } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.

// Argon Dashboard 2 PRO MUI components
import ArgonBox from "components/ArgonBox";

// Argon Dashboard 2 PRO MUI context
import { useArgonController, setLayout } from "context";

function PageLayout({ background, children }) {
  const [controller, dispatch] = useArgonController();
  const { darkMode } = controller;

  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "page");
  }, [pathname]);

  return (
    <ArgonBox
      width="100vw"
      height="100%"
      minHeight="100vh"
      bgColor={darkMode ? "transparent" : background}
      sx={{ overflowX: "hidden" }}
    >
      {children}
    </ArgonBox>
  );
}

// Setting default values for the props for PageLayout
PageLayout.defaultProps = {
  background: "default",
};

// Typechecking props for the PageLayout
PageLayout.propTypes = {
  background: PropTypes.oneOf(["white", "light", "default"]),
  children: PropTypes.node.isRequired,
};

export default PageLayout;

export function OnboardingLayout({ background, children, fullscreen }) {
  const [controller, dispatch] = useArgonController();
  const { darkMode } = controller;

  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "page");
  }, [pathname]);

  return (
    <ArgonBox
      width="100vw"
      height={fullscreen ? "100vh" : "100%"}
      minHeight="100vh"
      bgColor={darkMode ? "transparent" : background}
      sx={{
        overflowX: "hidden",
        margin: fullscreen ? 0 : "inherit",
        padding: fullscreen ? 0 : "inherit",
        position: fullscreen ? "fixed" : "relative",
        top: fullscreen ? 0 : "inherit",
        left: fullscreen ? 0 : "inherit",
        right: fullscreen ? 0 : "inherit",
        bottom: fullscreen ? 0 : "inherit",
      }}
    >
      {children}
    </ArgonBox>
  );
}

// Setting default values for the props for PageLayout
OnboardingLayout.defaultProps = {
  background: "default",
  fullscreen: true,
};

// Typechecking props for the PageLayout
OnboardingLayout.propTypes = {
  background: PropTypes.oneOf(["white", "light", "default"]),
  children: PropTypes.node.isRequired,
  fullscreen: PropTypes.bool,
};
